import React from 'react';

function OurStoryPage() {
  const imageCount = 8;
  const images = Array.from({ length: imageCount }, (_, i) => `/Images/ourstory/${i + 1}.png`);

  return (
    <div style={{ width: '100%', overflowX: 'hidden' }}>
      <h1
        style={{
          textAlign: 'center',
          margin: '20px 0',
          color: '#000000',
          backgroundColor: '#fff9c4', // light yellow
          padding: '10px 0',
        }}
      >
        Our Story
      </h1>

      {images.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`Story image ${index + 1}`}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            marginBottom: '10px',
          }}
        />
      ))}
    </div>
  );
}

export default OurStoryPage;
